module.exports = __webpack_public_path__ + "img/87ne.20c6f8b2.svg";